module.exports = __WEBPACK_EXTERNAL_createRequire(import.meta.url)("node:zlib");